export default __webpack_public_path__ + "static/media/desktop-full.611b3beb.jpg";